import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { sessionLogout as logout } from '../login/redux/authApi';
import Modal from '../../ui/Modal';
import useScreenWidth from '../common/helpers/useScreenWidth';
import Button from '../../ui/Button';
import { useHistory } from 'react-router';

const actions = {
  logout,
};

function ModalNotAuthorized({ logout }) {
  const history = useHistory();
  const screenWidth = useScreenWidth();

  return (
    <Modal
      variant='danger'
      label='Unauthorized'
      backgroundDark={true}
      width={screenWidth > 500 ? 500 : screenWidth}
    >
      <p className='px-4 my-5 mx-1 is-size-6 has-text-danger'>
        Anda tidak memiliki otoritas!
      </p>
      <div className='flex justify-end align-center pt-2 px-4 mx-1'>
        <div className='buttons'>
          <Button
            cvariant='clogout'
            onClick={() => logout('logoutModal', history)}
          />
        </div>
      </div>
    </Modal>
  );
}

export default withRouter(connect(null, actions)(ModalNotAuthorized));
